module.exports = __webpack_public_path__ + "static/media/non2.41af0290.jpg";